<script setup lang="ts">

import { ref } from 'vue';
import AssetQuantileTimePlot from './AssetQuantileTimePlot.vue';
import { Quantiles } from '../fin/quantile';
import { TimeSeries } from '../fin/history';

interface Props {
  calculationCompletionRatio: number;
  savingsQuantilesTS: TimeSeries<Quantiles>;
  criticalQuantileKey: number;
  birthYear: number;
  retirementYear: number;
  maxYear: number;
  exhausted: string;
  exhaustionYear: string;
  exhaustionAge: string;
}

const {
  calculationCompletionRatio = 0,
  savingsQuantilesTS = new TimeSeries<Quantiles>('ALL_SAVINGS', []),
  criticalQuantileKey = 0.05,
  birthYear = 0,
  retirementYear = 0,
  maxYear = 0,
  exhausted = '',
  exhaustionYear = '',
  exhaustionAge = '',
} = defineProps<Props>();

const savingsQuantileTimePlotRef = ref<InstanceType<typeof AssetQuantileTimePlot>|null>(null);

function redraw(): void {
  if (savingsQuantileTimePlotRef.value) {
    savingsQuantileTimePlotRef.value.redraw();
  }
}

defineExpose({redraw});

</script>

<template>
  <div class=output-card>
    <table><tbody>
      <tr>
        <td> exhausted </td>
        <td id="fin-output-value-exhausted"
            title="Did your chosen critical quantile run out of money before your specified maximum age?">
          {{exhausted}}
        </td>
      </tr><tr>
        <td> exhaustion year at selected critical quantile</td>
        <td id="fin-output-value-exhaustionYear"
            title="When the money runs out. If blank (and 'exhausted' is true), then max age is set too young, so the simulation finishes before it can use up your savings.">
          {{exhaustionYear}}
        </td>
      </tr><tr>
        <td> exhaustion age </td>
        <td id="fin-output-value-exhaustionAge"
            title="Age when the money runs out. If blank (and 'exhausted' is true), then max age is set too young, so the simulation finishes before it can use up your savings.">
          {{exhaustionAge}}
        </td>
      </tr>
    </tbody></table>
  </div>
  <AssetQuantileTimePlot
    ref="savingsQuantileTimePlotRef"
    :calculationCompletionRatio="calculationCompletionRatio"
    :series="savingsQuantilesTS"
    :criticalQuantileKey="criticalQuantileKey"
    :birthYear="birthYear"
    :retirementYear="retirementYear"
    :exhaustionYear="+exhaustionYear"
    :maxYear="maxYear" />
</template>

<style scoped>
</style>
